import {combineReducers} from "redux";

import areaStore from './areaStore'
import featureStore from './featureStore'
import profileStore from './profileStore'

const rootReducer = combineReducers({
    areaStore : areaStore,
    featureStore : featureStore,
    profileStore : profileStore
})

export default rootReducer;
